import { createContext } from 'react';

const ChartWrapperContext = createContext();

export default ChartWrapperContext;
